import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Haendler } from '../../../../../projects/kiene-core/src/lib/components/stammdaten/haendler/haendler';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { FormControl, Validators } from '@angular/forms';
import { HaendlerDetailsDialogComponent } from '../../../../../projects/kiene-core/src/lib/components/stammdaten/haendler/haendler-details-dialog/haendler-details-dialog.component';
import {
    GruppeTier,
    GruppeTierAbteilResult,
} from '../../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/gruppe-tier';

@Component({
    selector: 'kiene-haendler-aendern-dialog',
    templateUrl: './haendler-aendern-dialog.component.html',
    styleUrls: ['./haendler-aendern-dialog.component.scss'],
})
export class HaendlerAendernDialogComponent implements OnInit {
    public haendler: Haendler;
    public haendlerList: Haendler[] = [];
    haendlerCtrl = new FormControl(undefined, [Validators.required]);

    constructor(
        public dialogRef: MatDialogRef<HaendlerAendernDialogComponent>,
        private api: KieneBackendApiService,
        private messageService: MessageService,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) protected data: GruppeTier[],
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit(): void {
        this.loadHaendler();
    }

    loadHaendler(): void {
        const params = new HttpParams().set('favorit', 1);
        this.api.getAll(this.apiBaseUrl + 'viehhaendler/read_kundenportal.php', params).subscribe({
            next: response => {
                this.haendlerList = response.records;
            },
            error: error => {
                this.messageService.errorMessage('Fehler beim Laden der Haendler', error);
            },
        });
    }

    haendlerComparator(haendler1: Haendler, haendler2: Haendler): boolean {
        return haendler1 && haendler2
            ? haendler1.viehhaendler_id === haendler2.viehhaendler_id
            : haendler1 === haendler2;
    }

    public save(): void {
        this.haendler = this.haendlerCtrl.value;
        this.api
            .post(this.apiBaseUrl + 'gruppe_tier/update_viehhaendler.php ', {
                viehhaendler_id: this.haendler.viehhaendler_id,
                tiere: this.data,
            })
            .subscribe({
                next: () => {
                    const result = new GruppeTierAbteilResult();
                    result.confirm = true;
                    this.dialogRef.close(result);
                },
                error: error => {
                    this.messageService.errorMessage('Fehler beim updaten des Händlers', error);
                },
            });
    }

    openCreateHaendlerDialog() {
        const dialogRef = this.dialog.open(HaendlerDetailsDialogComponent);
        dialogRef.afterClosed().subscribe((result: Haendler) => {
            if (result) {
                this.haendlerCtrl.setValue(result);
                this.loadHaendler();
            }
        });
    }
}
